export const streamerEditorKeywords = [
  "streamer editor",
  "Twitch editor",
  "Twitch VOD editor",
  "stream editor",
  "gaming video editor",
  "Twitch clip editor",
  "Twitch clipper",
  "clipping campaigns",
  "gaming highlight editor",
  "hire video editor for Twitch",
];

export const supportedTwitchGamerCategories = [
  "TikTok clips",
  "Marvel Rivals",
  "Rainbow Six Siege",
  "YouTube",
  "Call of Duty",
  "Apex Legends",
  "League of Legends",
  "IRL",
  "Valorant",
  "Fortnite",
];

export const gameSeoCopy = {
  "tiktok-clips": {
    label: "TikTok clips",
    title: "TikTok Clippers and Clip Editors for Twitch Streamers",
    description:
      "Find clippers and short form editors for Twitch streams, gaming moments, and clipping campaigns built for TikTok, Shorts, and Reels.",
    bullets: [
      "Clipping campaigns from Twitch VODs and stream moments",
      "Short form pacing for TikTok, Shorts, and Reels",
      "Hooks, subtitles, zooms, memes, and retention focused cuts",
    ],
  },
  "marvel-rivals": {
    label: "Marvel Rivals",
    title: "Marvel Rivals Editors for Twitch Highlights",
    description:
      "Find Marvel Rivals editors for Twitch streamers who need teamfight highlights, clutch plays, hero moments, ranked clips, TikToks, Shorts, and YouTube gaming videos.",
    bullets: [
      "Teamfight edits, hero plays, and ranked highlights",
      "Fast cuts for chaotic fights and ability-heavy moments",
      "Short-form clips and YouTube gaming uploads",
    ],
  },
  "rainbow-six-siege": {
    label: "Rainbow Six Siege",
    title: "Rainbow Six Siege Editor for Stream Highlights",
    description:
      "Find Rainbow Six Siege editors for Twitch VODs, ranked clutches, operator plays, funny comms, stream clips, TikToks, Shorts, and YouTube gaming highlights.",
    bullets: [
      "Clutch round edits and tactical highlight reels",
      "Clean pacing around comms, setups, and final kills",
      "Stream clips for TikTok, Shorts, Reels, and YouTube",
    ],
  },
  youtube: {
    label: "YouTube",
    title: "YouTube Gaming Editor for Twitch Streamers",
    description:
      "Find YouTube gaming editors who can turn Twitch streams, VODs, gaming clips, and creator footage into long form videos, highlights, Shorts, and recurring uploads.",
    bullets: [
      "Long-form YouTube gaming edits from raw VODs",
      "Thumbnail-ready pacing, chapters, hooks, and story flow",
      "Shorts and highlight clips from longer uploads",
    ],
  },
  "call-of-duty": {
    label: "Call of Duty",
    title: "Call of Duty Editor for Twitch and YouTube",
    description:
      "Find Call of Duty editors for Twitch streamers, Warzone clips, multiplayer highlights, killstreaks, funny moments, TikToks, Shorts, and YouTube gaming videos.",
    bullets: [
      "Warzone and multiplayer highlight edits",
      "Fast action pacing for kills, streaks, and reactions",
      "Short-form clips and YouTube gaming uploads",
    ],
  },
  "apex-legends": {
    label: "Apex Legends",
    title: "Apex Legends Editor for Twitch Highlights",
    description:
      "Find Apex Legends editors for Twitch VODs, ranked highlights, clutch fights, movement clips, funny squad moments, TikToks, Shorts, and YouTube gaming content.",
    bullets: [
      "Ranked fights, squad wipes, and clutch endgames",
      "Movement-heavy pacing and clean fight storytelling",
      "Short-form edits and YouTube highlight videos",
    ],
  },
  "league-of-legends": {
    label: "League of Legends",
    title: "League of Legends Editor for Stream Highlights",
    description:
      "Find League of Legends editors for Twitch streamers who need ranked highlights, outplays, funny moments, champion clips, TikToks, Shorts, and YouTube videos.",
    bullets: [
      "Ranked highlights, outplays, and champion-focused edits",
      "Pacing around laning, teamfights, objectives, and reactions",
      "Stream clips for TikTok, Shorts, Reels, and YouTube",
    ],
  },
  irl: {
    label: "IRL",
    title: "IRL Stream Editor for Twitch Creators",
    description:
      "Find IRL stream editors who can turn Twitch VODs, reactions, travel moments, funny clips, and creator footage into highlights, TikToks, Shorts, and YouTube uploads.",
    bullets: [
      "IRL VOD cuts, reactions, and funny moments",
      "Story-driven pacing for personality-led content",
      "Short-form clips and YouTube creator videos",
    ],
  },
  valorant: {
    label: "Valorant",
    title: "Valorant Editor for Twitch Streamers",
    description:
      "Find Valorant editors for Twitch VODs, ranked clutches, ace highlights, funny comms, stream clips, TikToks, Shorts, and YouTube gaming videos.",
    bullets: [
      "Ace edits, clutch rounds, and ranked highlights",
      "Pacing around comms, utility, reactions, and final kills",
      "Short-form clips and YouTube gaming uploads",
    ],
  },
  fortnite: {
    label: "Fortnite",
    title: "Fortnite Editor for Twitch and Gaming Clips",
    description:
      "Find Fortnite editors for Twitch streamers who need gameplay highlights, creative clips, funny moments, TikToks, Shorts, Reels, and YouTube gaming videos.",
    bullets: [
      "Gameplay highlights, creative clips, and funny moments",
      "Fast short form pacing for TikTok, Shorts, and Reels",
      "YouTube gaming edits from streams and VODs",
    ],
  },
};

export function getGameSeoCopy(slug, categoryName = "this game") {
  return (
    gameSeoCopy[slug] || {
      label: categoryName,
      title: `${categoryName} Editor for Twitch Streamers`,
      description: `Find ${categoryName} editors for Twitch VODs, stream highlights, gaming clips, TikToks, Shorts, Reels, and YouTube gaming videos.`,
      bullets: [
        `Twitch VOD edits and ${categoryName} highlights`,
        "Stream clips for TikTok, Shorts, Reels, and YouTube",
        "Gaming editor portfolios built around creator workflows",
      ],
    }
  );
}
